export default __webpack_public_path__ + "static/media/Bannedicon.2f50cfb4.svg";